<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
        <template #header>
          <div class="d-flex align-items-center">
            
            <!-- LEFT SIDE TITLE -->
            <strong class="mr-auto">
              Hub User Delivery Configuration
            </strong>

            <!-- RIGHT SIDE BUTTONS -->
            <div>
              <b-button variant="success" @click="toggleForm">
                {{ showForm ? 'Add Configuration' : 'Add Configuration' }}
              </b-button>

              <b-button
                variant="info"
                class="ml-2"
                @click="toggleCsvUpload"
              >
                {{ showCsvUpload ? 'Bulk CSV Upload' : 'Bulk CSV Upload' }}
              </b-button>
            </div>
            <!-- <b-button variant="success" @click="cronAutoDeliverFromHubInScan" :disabled="isBusy">
                  cron Trigger HUbInscan To Delivery
              </b-button> -->

          </div>
        </template>

          <!-- add FORM -->
        <div id="hubUserConfigForm"
            class="form-container"
            :class="{ 'edit-mode': editMode }"
            v-if="showForm">
          <div class="form-title">
            {{ editMode ? 'Edit Configuration' : 'Add Configuration' }}
          </div>
           <b-row>
            <!-- USER -->
            <b-col md="4">
              <b-form-group label="Select User ID">
                <v-select
                  v-model="valueUser"
                  :options="optionsUser"
                  label="label"
                  placeholder="Select User"
                />
              </b-form-group>
            </b-col>

            <!-- WAREHOUSE -->
            <b-col md="4">
              <b-form-group label="Select Hub">
                <v-select
                  v-model="valueHub"
                  :options="optionsHub"
                  label="label"
                  placeholder="Select Warehouse"
                />
              </b-form-group>
            </b-col>

            <!-- PO TYPE -->
            <b-col md="4">
              <b-form-group label="Select PO Type">
                <v-select
                  v-model="valuePotype"
                  :options="optionsPotype"
                  multiple
                  label="value"
                  placeholder="Select PO Type"
                />
              </b-form-group>
            </b-col>

            <!-- ACTIVE -->
            <b-col md="4">
              <b-form-group label="Is Active">
                <b-form-select v-model="isActive" :options="isActiveOptions"/>
              </b-form-group>
            </b-col>

           

            <!-- BUTTON -->
            <b-col md="4" class="mt-4">
             
              <b-button
                  variant="primary"
                  @click="saveConfiguration"
              >
                  {{ editMode ? 'Update' : 'Submit' }}
              </b-button>

              <b-button variant="secondary" class="ml-2" @click="resetForm">
                Reset
              </b-button>
            </b-col>
          </b-row>
        </div>
          <!-- Upload CSV / FORM -->
      <div v-if="showCsvUpload" class="form-container">

        <!-- TITLE -->
        <div class="form-title">
          Upload Configuration
        </div>

          <b-row >
            <b-col md="7">
              <b-row>
                <b-col md="3">
                  <label><b>Upload CSV File</b></label>
                  <span style="color: red;">*</span>
                </b-col>

                <b-col md="8">
                  <b-form-group>
                    <b-form-file
                      type="file"
                      v-model="file"
                      :state="Boolean(file)"
                      @change="selectcsvFiletoUpload($event)"
                      placeholder="Upload CSV File"
                      accept=".csv"
                    ></b-form-file>
                  </b-form-group>
                  <a
                        href="img/hubUserDeliveryConfiguration.csv"
                        download="hubUserDeliveryConfiguration.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                       <br/>
                       <small class="text-muted">
                        Note: Configuration IsActive accepts  only <b>1 (Yes)</b> or <b>0 (No)</b>.
                    </small>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="5">
              <b-row>
                <b-col md="2">
                  <b-button
                    variant="primary"
                    @click="uploadcsv()"
                    :disabled="isReadOnly"
                  >
                    Submit
                  </b-button>
                </b-col>

                <b-col md="2">
                  <b-button variant="danger" @click="clearcsv()">
                    Clear
                  </b-button>
                </b-col>

                <b-col md="4">
                  <a :href="downlaodcsv + 'sysusermasterid=' + Usersysuser" target="_blank">
                    <b-button variant="primary">Download CSV</b-button>
                  </a>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          </div>


          <!-- TABLE -->
          <b-row>
            <b-col sm="12">
              <b>Total Records:
                <span style="color:red">{{ routertotalRows }}</span>
              </b>



              <b-table show-empty responsive
                :items="hubUserDeliveryDataResult"
                :fields="Routesdetailsfields"
                :busy="isBusy"                
                :filter="filter"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
            :bordered="bordered"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>

               <template  slot="is_active" slot-scope="row">
                  <span v-if="row.item.is_active === true || row.item.is_active === 'true'">
                    Active
                  </span>
                  <span v-else>
                    Inactive
                  </span>
                </template>
               <template slot="action" slot-scope="row">
                    <b-button 
                    size="sm" @click="editinfoModal(row.item)" data-toggle="tooltip"
                    title="Update Hub User Delivery Configuration" style="background: #b0c4de !important;color: #000 !important;" class="mb-1" >
                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </b-button>
              </template>
              </b-table>
            </b-col>
          </b-row>

          <!-- PAGINATION -->
          <b-row>
            <b-col sm="12" class="mt-3">
               <paginate 
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                </paginate>
            </b-col>
          </b-row>
        </b-card>

        <!-- LOADER -->
        <div v-if="loading" class="overlay">
          <div class="loader"></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
   data() {
      return {
            showForm: false,
            showCsvUpload: false,
            file1: null,
            selectcsvFile:'',
            file:'',
            selectFiletype:'',
            myToggle: false,
            downlaodcsv :'',
            Routesdetailsfields: [
                { key: 'user_id', label: 'User Id', sortable: true},
                { key: 'hub_id', label: 'Hub ID', sortable: true},
                { key: 'po_types', label: 'PO Types', sortable: true},
                { key: 'is_active', label: 'Active / Inactive', sortable: true},
                { key: 'createdby', label: 'Created By', sortable: true},
                { key: 'createddate', label: 'Created Date', sortable: true},
                { key: 'modifiedby', label: 'Modified By', sortable: true},
                { key: 'modifieddate', label: 'Modified Date', sortable: true},
                { key: "action", label: " Actions", class: "actionAdmin" },
            ],
            hubUserDeliveryDataResult :[],
            routertotalRows :0,           
            Usersysuser :'',
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            accessBody:[],
            isReadOnly:false,
            resultdata:{},

            valueUser: null,
            valueHub: null,
            valuePotype: [],
            isActive: true,
           isActiveOptions:[
                {
                    text:'Active',
                    value:true
                },
                {
                    text:'Inactive',
                    value:false
                }
            ],
            optionsUser: [],
            optionsHub: [],
            optionsPotype: [],
            editMode:false,
            editId:null,
            loading:false,
            isBusy:false,
            filter:'',
            sortBy:'',
            sortDesc:false,
            sortDirection:'asc',
            bordered:true,
        }
   },
   created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType=userInfo.user_type;
      this.Usersysuser=userInfo.sysusermasterid;
    this.user_id = userInfo.sysusermasterid;
    this.listHubUserDeliveryConfig(this.pageNum);
    const csvurl = `${CONSTANTS.MIGRATION_API_URL}/downloadHubUserDeliveryConfigCSV?`
    this.downlaodcsv=csvurl;
    this.accessBody = userInfo.body;
    this.ischeckbodyvalidation();
   

   },

    methods: {
      async cronAutoDeliverFromHubInScan() {
          try {
              let result = await this.$http.get(
                  `${CONSTANTS.MIGRATION_API_URL}/cronAutoDeliverFromHubInScan`
              );
              if (result.body.returnmsg == "Successful") {
                  this.$fire({
                      type: "success",
                      text:`${result.body.returnvalue} Total : ${result.body.totalSMS}
                        Success : ${result.body.success}
                        Failed : ${result.body.failed}`,
                      timer: 5000
                  });
              } else {
                  this.$fire({
                      type: "error",
                      text: result.body.returnvalue,
                      timer: 5000
                  });
              }

          } catch (ex) {
              this.$fire({
                  type: "error",
                  text: ex.message,
                  timer: 5000
              });
          }
      },
      editinfoModal(item) {
        this.editMode = true;
        this.showForm = true;
        this.showCsvUpload = false;
        this.$nextTick(() => {
                const form = document.getElementById("hubUserConfigForm");
                if (form) {
                    form.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                }
            });
        this.editId = item.id;

       this.valueUser =
        this.optionsUser.find(
            x => x.value == item.user_id
        );

        this.valueHub =
        this.optionsHub.find(
            x => x.value == item.hub_id
        );

         let poTypes = item.po_types.split(",");

        this.valuePotype = this.optionsPotype.filter(
            x => poTypes.includes(x.value)
        );

         this.isActive = item.is_active;
      },
      toggleCsvUpload() {
        this.showCsvUpload = !this.showCsvUpload;
        this.showForm = false;

        if (!this.showCsvUpload) {
          this.file = null; // clear file
        }
      },
     async toggleForm() {
          this.editMode = false;
          this.showForm = !this.showForm;
          this.showCsvUpload = false;

          if (this.showForm) {

              // Load dropdowns only once
              if (
                  this.optionsUser.length === 0 ||
                  this.optionsHub.length === 0 ||
                  this.optionsPotype.length === 0
              ) {
                  await this.getalldata();
              }

              this.resetForm();
          }
      },
        resetForm() {
        this.editMode=false;
        this.editId=null;
        this.valueUser = null;
        this.valueHub = null;
        this.valuePotype = [];
        this.isActive = true;
        },
        getalldata() {

            this.$http
                .post(`${CONSTANTS.MISREPORT_API_URL}/getHubUserDetailsAndHubData`)
                .then(result => {

                if (result.body.returnmsg.toLowerCase() === "successful") {

                    this.resultdata = result.body.returnvalue

                  this.optionsUser = this.resultdata.users.map(u => ({
                    label: `${u.userid} - ${u.destinationcompanyname}`,
                    value: u.userid,
                    name: u.destinationcompanyname
                    }))

                
                    this.optionsHub = this.resultdata.hubs.map(h => ({
                      label: `${h.hub_name} - ${h.hub_id}`,
                      value: h.hub_id,
                      name: h.hub_name
                  }))

                    this.optionsPotype = this.resultdata.loadpotypes.map(p => ({
                    label: p,
                    value: p
                    }))

                }

            })
        },
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Route Details' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        selectcsvFiletoUpload :function (event){
            this.selectcsvFile= event.target.files[0];
            console.log("HHH",this.selectcsvFile);

            this.selectFiletype= event.target.files[0].type;
            console.log("selectFiletype",this.selectFiletype);
        },

        clearcsv :function () {
            this.file ='';
        },

        uploadcsv :function (){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            document.getElementById("overlay").style.display = "block";
            if(this.selectFiletype == 'text/csv'){
                let data = new FormData();
                            data.append('file', this.selectcsvFile)
                            data.append('createdby', `${userInfo.userfirstname}` + ' ' + `${userInfo.userlastname}`)
                            data.append('sysusermasterid', `${userInfo.sysusermasterid}`)
                        let config = {
                            header : {
                            'Content-Type' : 'multipart/form-data'
                            }
                            }
                            console.log("Config",config);
                        // return false;
                        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadHubUserDeliveryConfigCSV`,data,{ header : {
                            'Content-Type' : 'multipart/form-data'
                            } }).then(result => {
                            console.log("YYY",result);
                            if (result.body.returnmsg === 'Successful') {
                             let res = result.body.returnvalue;

                          let message = `
                            Inserted : ${res.summary.totalInserted}
                            Updated : ${res.summary.totalUpdated}
                            Skipped : ${res.summary.totalSkipped}
                            Failed : ${res.summary.totalFailed}
                            `;

                            if (res.failedRecords && res.failedRecords.length > 0) {
                                message += "\n\nFailed Records:\n";
                                res.failedRecords.forEach(record => {
                                    message +=
                `Row ${record.rowno}\n` +
                `Hub : ${record.hub_id}\n` +
                `User : ${record.user_id}\n` +
                `PO Type : ${record.po_type}\n` +
                `Reason : ${record.reason}\n\n`;
                                });
                            }
                          
                            this.$fire({
        title: "CSV Upload Summary",
        text: message,
        type: res.summary.totalFailed > 0 ? "warning" : "success",
        showCancelButton: res.summary.totalFailed > 0,
        confirmButtonText: res.summary.totalFailed > 0
            ? "Download Failed CSV"
            : "OK",
        cancelButtonText: "Close"
    }).then(response => {

        if (
            response.value &&
            res.failedCSV
        ) {
            window.open(res.failedCSV, "_blank");
        }

    });
                            

                                document.getElementById("overlay").style.display = "none";
                                this.file ='';
                                this.selectcsvFile='';
                                this.selectFiletype='';
                                this.listHubUserDeliveryConfig(this.pageNum);
                }else{
                            this.file ='';
                            this.$fire({
                            text:result.body.returnvalue,
                            type: "error",
                            timer: 30000
                            }); 
                            document.getElementById("overlay").style.display = "none";
                }
                })
                .catch(ex => {
                console.log("error", ex);
                });
            }
            else{
              document.getElementById("overlay").style.display = "none";
            this.file ='';
            this.$fire({
                        text:"Please Upload CSV File Only",
                        type: "error",
                        timer: 30000
                    }); 
            }
        },

        clickCallback (pageNum){
          this.listingpageno = pageNum;
          console.log("pageNum",this.listingpageno)
           this.listHubUserDeliveryConfig(pageNum);
        },
        async saveConfiguration() {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            if (!this.valueUser || !this.valueHub || !this.valuePotype.length) {
              alert("Please fill all fields");
              return;
            }

            this.isBusy = true;

            let payload={
              id: this.editMode ? this.editId : undefined,   // 👈 important
              hub_id:this.valueHub.value,
              selectuserid:this.valueUser.value,
              po_types:this.valuePotype.map(x=>x.value),
              is_active:this.isActive,
              createdby:userInfo.sysemailid
            };

            let apiUrl = this.editMode
              ? `${CONSTANTS.MIGRATION_API_URL}/updateHubUserDeliveryConfig`   // 👈 UPDATE API
              : `${CONSTANTS.MIGRATION_API_URL}/addHubUserDeliveryConfig`;

            try {
              let result = await this.$http.post(apiUrl, payload);
              this.isBusy = false;
              if (result.body.returnmsg === "Successful") {
                    let msg = "";
                    if (result.body.returnvalue.inserted &&
                        result.body.returnvalue.inserted.length > 0) {
                        msg += "Inserted : " +
                            result.body.returnvalue.inserted.join(", ");
                    }

                    if (result.body.returnvalue.skipped &&
                        result.body.returnvalue.skipped.length > 0) {
                        msg += "\nAlready Exists : " +
                            result.body.returnvalue.skipped.join(", ");
                    }
                    this.$fire({
                        text: msg,
                        type: "success",
                        timer: 5000
                    });
                    this.listHubUserDeliveryConfig(this.pageNum);
                    this.resetForm();
                    this.editMode = false;
                    this.editId = null;
                } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 3000
                });
              }

            } catch (error) {
              console.error(error);
            }
          },
       
        listHubUserDeliveryConfig : function(pageNo){

            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                pageno:`${pageNo}`,
            }
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getHubUserDeliveryConfig`,obj).then(result => {
                    this.isBusy=false;
                    console.log("result",result)
                    if (result.body.returnmsg === "Successful") {
                    this.hubUserDeliveryDataResult=result.body.returnvalue;
                    console.log("hubUserDeliveryDataResult",this.hubUserDeliveryDataResult);
                    this.routertotalRows=result.body.totalcount;
                    this.noofpages=parseInt(this.routertotalRows)/10;
                    this.noofpages=Math.ceil( this.noofpages);
                    }else{
                        this.hubUserDeliveryDataResult=[];
                        this.routertotalRows=0;
                    }
                    }).catch(ex => {
                    console.log("error", ex);
                });
        }

    },
}
</script>

<style>
.edit-mode {
    border: 2px solid #007bff;
    background: #eef6ff;
    animation: highlight 0.5s;
}

@keyframes highlight {
    from {
        background: #fff9c4;
    }
    to {
        background: #eef6ff;
    }
}
.form-container {
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #fafafa;
  position: relative;
}

.form-title {
  position: absolute;
  top: -12px;
  left: 15px;
  background: white;
  padding: 0 10px;
  font-weight: 600;
  font-size: 14px;
  color: #007bff;
}
.routetable th, td {
    text-align: center;
}
.route-border {
    border-bottom: 1px solid #c9bebe;
    margin: 30px 0px 20px 0px;
}
</style>